import * as Sentry from '@sentry/browser';

import Config from 'modules/config';

// if (Config.ENV !== 'development') {
Sentry.init({
  dsn: Config.SENTRY_DSN,
  release: Config.VERSION_STRING,
  environment: Config.ENV,
});
// Sentry.config(Config.SENTRY_DSN, {
//   release: Config.VERSION_STRING,
//   environment: Config.ENV,
// }).install();
// // }

export default Sentry;
